import Immutable from 'immutable';
import initialStepValidation from 'reducers/work-order/close-step-validation/initialStepValidation';
import {
  getCustomerOwnedOutlet,
  isOutletIpve,
  getCustomerOwnedOutletNotBeingRemoved,
  hasWowMangedSetUpBox
} from '../../utils/byodServiceCodeUtils';
import {
  byodServiceCode,
  CUSTOMER_BYOD_TEXT
} from '../../constants/byodCodesConfig';

export const getOrderDetailFinished = (state, action) => {

  if (action.key === 'charges') {

    action
      .payload
      .map((item) => {
        item.isValid = true;
        return item;
      });

    state = state.setIn([
      'workOrderDetails',
      action.orderId,
      'charges',
      'chargeGroups',
      'serviceCallFee',
      'hidden'
    ], false);

  }

  if (action.key === 'orderDetails') {
    state = state.setIn([
      'workOrderDetails', action.orderId, 'orderClose', 'details', 'currentStep'
    ], 0);

    state = state.setIn([
      'workOrderDetails', action.orderId, 'orderClose', 'details', 'stepValidation'
    ], initialStepValidation);
  }

  if(action.key === 'packageDetails') {
    const dongleEquipment = Immutable.fromJS({loading: false, isSuccess: false, message: ''})
    state = state.setIn(['workOrderDetails', action.orderId, 'dongleEquipmentAdd'], dongleEquipment);
    
    const cpeEquipment = Immutable.fromJS({loading: false, isSuccess: false, message: ''})
    state = state.setIn(['workOrderDetails', action.orderId, 'cpeEquipmentAdd'], cpeEquipment);
  }

  if (action.key === 'equipmentDetails') {
    const items = action.payload;
    const immutableItems = Immutable.fromJS(items);
    // Determinate when to disable whole dropdown and when just disable all dropdown options except remove

    items.forEach((item) => {

      const isByodOutlet = getCustomerOwnedOutlet(item);
      const isByodOutletNotBeingRemoved = getCustomerOwnedOutletNotBeingRemoved(item);
      const isIpvePortType = isOutletIpve(item);
      const hasWowManagedStb = hasWowMangedSetUpBox(item);
      const hasByodTvPlusDevice = isIpvePortType && !hasWowManagedStb && item.seriaNumber;

      if (isByodOutlet && (isByodOutletNotBeingRemoved || hasByodTvPlusDevice)) {
        item.disableAddsAndSwaps = true;
        if (hasByodTvPlusDevice || isByodOutletNotBeingRemoved && !item.seriaNumber) {
          item.make = CUSTOMER_BYOD_TEXT;
        }
      }
      if (item.make === 'CUSTMODEM') {
        if ((item.macAddress === null || item.macAddress === '') && item.seriaNumber && item.seriaNumber.length === 12) {
          item.macAddress = item.seriaNumber;
        }
      }
    });

    state.setIn([
      'workOrderDetails', action.orderId, action.key, 'details'
    ], Immutable.fromJS(items));
  }

  return state.setIn([
    'workOrderDetails', action.orderId, action.key, 'loading'
  ], false).setIn([
    'workOrderDetails', action.orderId, action.key, 'loadingFinished'
  ], true).setIn([
    'workOrderDetails', action.orderId, action.key, 'details'
  ], Immutable.fromJS(action.payload)).setIn([
    'workOrderDetails', action.orderId, 'lastUpdated'
  ], action.timestamp);

};
export const getOrderDetailFailed = (state, action) => {
  return state.setIn([
    'workOrderDetails', action.orderId, action.key, 'loading'
  ], false).setIn([
    'workOrderDetails', action.orderId, action.key, 'loadingFinished'
  ], true).setIn([
    'workOrderDetails', action.orderId, action.key, 'error'
  ], Immutable.fromJS(action.payload.message)).setIn([
    'workOrderDetails', action.orderId, action.key, 'isError'
  ], true);

};
export const clearOrderDetail = (state, action) => {
  if (action.key) {
    let next = state
      .deleteIn(['workOrderDetails', action.orderId, action.key, 'details'])
      .setIn(['workOrderDetails', action.orderId, action.key, 'loadingFinished'], false);

    if (action.key === 'equipmentDetails' && action.clearOutletUpdateMessage) {
      next = next
        .setIn(['workOrderDetails', action.orderId, action.key, 'outletUpdateMessage'], null)
        .setIn(['workOrderDetails', action.orderId, action.key, 'outletUpdatePendingMessage'], null);
    }

    return next;
  }
  return state.deleteIn(['workOrderDetails', action.orderId]);

};

export const getWorkOrderStarted = (state, action) => {
  return state.setIn([
    'workOrderDetails', action.request.orderId, action.config.key, 'loading'
  ], true).setIn([
    'workOrderDetails', action.request.orderId, action.config.key, 'loadingFinished'
  ], false).setIn([
    'workOrderDetails', action.request.orderId, action.config.key, 'isError'
  ], false).setIn([
    'workOrderDetails', action.request.orderId, action.config.key, 'error'
  ], null);

};

export const ordeDetailPageOpened = (state, action) => {
  return state.setIn([
    'workOrderDetails', action.orderId, 'lastUpdated'
  ], action.timestamp).setIn([
    'workOrderDetails', action.orderId, 'sqcHistoryDialog', 'collapsed'
  ], true).setIn([
    'workOrderDetails', action.orderId, 'portDetails', 'collapsed'
  ], true);

};

export const ordeDetailByIdFinished = (state, action) => {

  if (action.payload && action.payload.assignedServiceOrders && action.payload.assignedServiceOrders.length >= 1) {
    const result = Immutable
      .fromJS(action.payload.assignedServiceOrders)
      .first();

    return state.setIn([
      'workOrderDetails', action.orderId, 'schedulingSystemDetails', 'details'
    ], result).setIn([
      'workOrderDetails', action.orderId, 'schedulingSystemDetails', 'loading'
    ], false).setIn([
      'workOrderDetails', action.orderId, 'schedulingSystemDetails', 'loadingFinished'
    ], true);
  }

  return state;

};

export const ordeDetailByIdStarted = (state, action) => {

  return state.setIn([
    'workOrderDetails', action.orderId, 'schedulingSystemDetails', 'loading'
  ], true).setIn([
    'workOrderDetails', action.orderId, 'schedulingSystemDetails', 'loadingFinished'
  ], false);

};

export const getOrderHistoryStarted = (state, action) => {
  return state.setIn([
    'workOrderDetails', action.orderId, 'addressHistory', 'loading'
  ], true).setIn([
    'workOrderDetails', action.orderId, 'addressHistory', 'loadingFinished'
  ], false).setIn([
    'workOrderDetails', action.orderId, 'addressHistory', 'isError'
  ], false).setIn([
    'workOrderDetails', action.orderId, 'addressHistory', 'error'
  ], null);
};

export const getOrderHistoryFinished = (state, action) => {
  return state.setIn([
    'workOrderDetails', action.orderId, 'addressHistory', 'loading'
  ], false).setIn([
    'workOrderDetails', action.orderId, 'addressHistory', 'loadingFinished'
  ], true).setIn([
    'workOrderDetails', action.orderId, 'addressHistory', 'isError'
  ], false).setIn([
    'workOrderDetails', action.orderId, 'addressHistory', 'error'
  ], null).setIn([
    'workOrderDetails', action.orderId, 'addressHistory', 'details'
  ], action.payload.fstCustomerHistoryReport);
};

export const getOrderHistoryFailed = (state, action) => {
  return state.setIn([
    'workOrderDetails', action.orderId, 'addressHistory', 'loading'
  ], false).setIn([
    'workOrderDetails', action.orderId, 'addressHistory', 'loadingFinished'
  ], true).setIn([
    'workOrderDetails', action.orderId, 'addressHistory', 'isError'
  ], true).setIn([
    'workOrderDetails', action.orderId, 'addressHistory', 'error'
  ], action.payload);
};

export const setNewCustomerEmail = (state, action) => {
  return state.setIn([
    'workOrderDetails', action.orderId, 'customerDetails', 'details', action.isLoginEmail ? 'newEmailLogin' : 'newEmailContact', 'value'
  ], action.email);
};

export const setCustomerEmailEditMode = (state, action) => {
  return state.setIn([
    'workOrderDetails', action.orderId, 'customerDetails', 'details', action.isLoginEmail ? 'newEmailLogin' : 'newEmailContact', 'editMode'
  ], action.value);
};

export const resetCustomerEmailChanges = (state, action) => {
  return state.setIn([
    'workOrderDetails', action.orderId, 'customerDetails', 'details', action.isLoginEmail ? 'newEmailLogin' : 'newEmailContact', 'value'
  ], null).setIn([
    'workOrderDetails', action.orderId, 'customerDetails', 'details', action.isLoginEmail ? 'newEmailLogin' : 'newEmailContact', 'editMode'
  ], false);
};

export const updateCustomerEmailStarted = (state, action) => {
  return state.setIn([
    'workOrderDetails', action.orderId, 'customerDetails', 'details', 'newEmail', 'loading'
  ], true).setIn([
    'workOrderDetails', action.orderId, 'customerDetails', 'details', 'newEmail', 'loadingFinished'
  ], false).setIn([
    'workOrderDetails', action.orderId, 'customerDetails', 'details', 'newEmail', 'isError'
  ], false).setIn([
    'workOrderDetails', action.orderId, 'customerDetails', 'details', 'newEmail', 'error'
  ], null);
};

export const updateCustomerEmailFinished = (state, action) => {
  return state.setIn(
    ['workOrderDetails', action.orderId, 'customerDetails', 'details', 'newEmail'],
    Immutable.fromJS({
      loading: false,
      loadingFinished: true,
      isError: false,
      error: null,
      successData: action.payload
    })
  ).setIn(
    ['workOrderDetails', action.orderId, 'customerDetails', 'details', action.isLoginEmail ? 'newEmailLogin' : 'newEmailContact'],
    Immutable.fromJS({
      editMode: false,
    })
  ).setIn([
    'workOrderDetails', action.orderId, 'customerDetails', 'details', action.isLoginEmail ? 'loginEmail' : 'contactEmail'
  ], state.getIn([
    'workOrderDetails', action.orderId, 'customerDetails', 'details', action.isLoginEmail ? 'newEmailLogin' : 'newEmailContact', 'value'
  ]));
};

export const updateCustomerEmailFailed = (state, action) => {
  return state.setIn(
    ['workOrderDetails', action.orderId, 'customerDetails', 'details', 'newEmail'],
    Immutable.fromJS({
      loading: false,
      loadingFinished: true,
      isError: true,
      errorData: action.payload,
      status: action.status,
    })
  ).setIn(
    ['workOrderDetails', action.orderId, 'customerDetails', 'details', action.isLoginEmail ? 'newEmailLogin' : 'newEmailContact'],
    Immutable.fromJS({
      editMode: false,
    })
  );
};

export const updateCustomerEmailMessageReset = (state, action) => {
  const newEmailPath = [
    'workOrderDetails',
    action.orderId,
    'customerDetails',
    'details',
    'newEmail'
  ];

  return state
    .removeIn([...newEmailPath, 'successData'])
    .removeIn([...newEmailPath, 'errorData'])
    .removeIn([...newEmailPath, 'status']);
};

export const getAddressFromBillerStarted = (state, action) => {
  return state.setIn([
    'workOrderDetails', action.orderId, 'billerAddress', 'loading'
  ], true).setIn([
    'workOrderDetails', action.orderId, 'billerAddress', 'loadingFinished'
  ], false).setIn([
    'workOrderDetails', action.orderId, 'billerAddress', 'isError'
  ], false).setIn([
    'workOrderDetails', action.orderId, 'billerAddress', 'error'
  ], null).setIn([
    'workOrderDetails', action.orderId, 'billerAddress', 'details'
  ], null);
};

export const getAddressFromBillerFinished = (state, action) => {
  return state.setIn([
    'workOrderDetails', action.orderId, 'billerAddress', 'loading'
  ], false).setIn([
    'workOrderDetails', action.orderId, 'billerAddress', 'loadingFinished'
  ], true).setIn([
    'workOrderDetails', action.orderId, 'billerAddress', 'isError'
  ], false).setIn([
    'workOrderDetails', action.orderId, 'billerAddress', 'error'
  ], null).setIn([
    'workOrderDetails', action.orderId, 'billerAddress', 'details'
  ], action.payload);
};

export const getAddressFromBillerFailed = (state, action) => {
  return state.setIn([
    'workOrderDetails', action.orderId, 'billerAddress', 'loading'
  ], false).setIn([
    'workOrderDetails', action.orderId, 'billerAddress', 'loadingFinished'
  ], true).setIn([
    'workOrderDetails', action.orderId, 'billerAddress', 'isError'
  ], true).setIn([
    'workOrderDetails', action.orderId, 'billerAddress', 'error'
  ], action.payload).setIn([
    'workOrderDetails', action.orderId, 'billerAddress', 'details'
  ], null);
};

export const asurionPlusEnrollmentStarted = (state, action) => {
  return setAccountAddLoading(state, action.orderId, 'accountAdd', true);
};

export const asurionPlusEnrollmentFinished = (state, action) => {
  return setAccountAddLoading(state, action.orderId, 'accountAdd', false);
};

export const asurionPlusEnrollmentFailed = (state, action) => {
  return setAccountAddLoading(state, action.orderId, 'accountAdd', false);
};

export const addEquipmentBySerialStarted = (state, action) => {
  return setAccountAddLoading(state, action.orderId, action.path, true);
}

export const addEquipmentBySerialFinished = (state, action) => {
  state = state.setIn(['workOrderDetails', action.orderId, action.path, 'isSuccess'], action.payload.isSuccess).setIn([
    'workOrderDetails', action.orderId, action.path, 'message'], action.payload.message);
  return setAccountAddLoading(state, action.orderId, action.path, false);
}

export const addEquipmentBySerialFailed = (state, action) => {
  state = state.setIn(['workOrderDetails', action.orderId, action.path, 'isSuccess'], false).setIn([
    'workOrderDetails', action.orderId, action.path, 'message'], 'Failed to add equipment');
  return setAccountAddLoading(state, action.orderId, action.path,  false);
}

function setAccountAddLoading(state, orderId, path, loading) {
  return state.setIn(['workOrderDetails', orderId, path, 'loading'], loading);
}

export const resetCpeEquipmentAdd = (state, action) => {
return state.setIn(['workOrderDetails', action.orderId, action.path], Immutable.fromJS({loading: false, isSuccess: false, message: ''}));
}



// WEBPACK FOOTER //
// ./src/reducers/work-order/orderDetails.js